import React, { useEffect } from 'react';

import './Roulette.css';
import { playAudio } from '../../../Utils';

const RouletteWheel = (props) => {
  let style;
  let wheel;
  let ballTrack;
  let resultSpan;
  const wheelnumbersAC = [
    0, 10, 3, 8, 12, 11, 7, 13, 18, 6, 9, 17, 14, 2, 1, 4, 16, 15, 5,
  ];

  useEffect(() => {
    if (props.result !== null) {
      wheel = document.getElementsByClassName('wheel')[0];
      ballTrack = document.getElementsByClassName('ballTrack')[0];
      resultSpan = document.getElementsByClassName('resultNumber')[0];
      spin(props.result);
    }
  }, [props.result]);

  const spin = (number: number) => {
    spinWheel(number);
    playAudio('/GameSound/roulette-spinning.mp3');
  };

  function spinWheel(winningSpin: number) {
    let degree = 0;
    for (let i = 0; i < wheelnumbersAC.length; i++) {
      if (wheelnumbersAC[i] === winningSpin) {
        degree = i * 18.947 + 360;
      }
    }

    wheel.style.cssText = 'animation: wheelRotate 6s linear infinite;';
    ballTrack.style.cssText = 'animation: ballRotate 1.2s linear infinite;';

    setTimeout(() => {
      ballTrack.style.cssText = 'animation: ballRotate 2.4s linear infinite;';
      style = document.createElement('style');
      style.type = 'text/css';
      style.innerText =
        '@keyframes ballStop {from {transform: rotate(0deg);}to{transform: rotate(-' +
        degree +
        'deg);}}';
      document.head.appendChild(style);
    }, 2400);

    setTimeout(() => {
      ballTrack.style.cssText = 'animation: ballStop 3.6s linear;';
    }, 7200);

    setTimeout(() => {
      ballTrack.style.cssText = 'transform: rotate(-' + degree + 'deg);';
    }, 10800);

    setTimeout(() => {
      // wheel.style.cssText = '';
      wheel.style.cssText = 'animation: wheelRotate 12s linear infinite;';
      style.remove();
      resultSpan.innerText = winningSpin;
    }, 12000);
  }

  return (
    <div className='main_layout_wheel'>
      <div className='main_layout_inner col_center'>
        <div className='wheel_container'>
          <div className='wheel'>
            <div className='ballTrack'>
              <div className='ball' />
            </div>
          </div>
          <div className="outerRim"></div>
          <div className='cone'>
            <span className='resultNumber' />
          </div>
        </div>
      </div>
    </div>
  );
};

export default RouletteWheel;
